import React from 'react';
import PropTypes from 'prop-types';

import { ProgressBar as CommonProgressBar } from '@dtvgo/web-player-ui';
import { useSeeking } from '@dtvgo/player-context';

export default function ProgressBar({
  className,
  progress,
  duration,
  seekable,
  gaps,
  onSeek,
  children,
}) {
  return (
    <CommonProgressBar
      className={className}
      progress={progress}
      duration={duration}
      seekable={seekable}
      gaps={gaps}
      seeking={useSeeking().isSeeking}
      onSeek={onSeek}
    >
      <CommonProgressBar.ProgressFill />
      <CommonProgressBar.ProgressDot />
      {children}
      {/* Elapsed strip (Chromecast live bar); avoids empty track when seekable.start ≈ progress.
       Omit SeekableStartFill: large start would shade the whole bar (high z-index in DS). */}
      <CommonProgressBar.SeekableEndFill />
      <CommonProgressBar.MouseOver />
    </CommonProgressBar>
  );
}

ProgressBar.propTypes = {
  className: PropTypes.string,
  progress: PropTypes.number,
  duration: PropTypes.number,
  seekable: PropTypes.shape({
    start: PropTypes.number,
    end: PropTypes.number,
  }),
  gaps: PropTypes.arrayOf(PropTypes.number),
  onSeek: PropTypes.func,
  children: PropTypes.node,
};

ProgressBar.defaultProps = {
  className: '',
  progress: 0,
  duration: 0,
  seekable: undefined,
  gaps: undefined,
  onSeek: undefined,
  children: null,
};
